import ZoomInIcon from '@material-ui/icons/ZoomIn';
import React, {useEffect, useRef, useState} from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button";
import {ApolloMessage} from "../../../atom/Apollo_Mesasge";
import {apollo_useStyles, options_ms_campaign_type, options_select_ms_campaign_type, options_state_edit_ms} from "../../../atom/Apollo_styles";
import {APOLLO_GROUP_OPERATOR, APOLLO_SYSTEM_ADMIN, ApolloUserProfileAuth} from "../../../atom/Apollo_Authorization";
import {useForm} from "react-hook-form";
import {useHistory} from "react-router-dom";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {AdAsset} from "../../CRASSET/ms/common/AdAssetModel";
import {colors, MuiThemeProvider, TextField} from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import {
    advertisementsms_path,
    get_ms_adgroup_path,
    get_ms_adgroups_path,
    get_ms_advertisement_path,
    get_ms_assets_path,
    get_ms_campaigns_path,
    post_ms_advertisement_path,
    put_ms_advertisement_path
} from "../../../atom/Apollo_links";
import {ApolloBasicSelect, ApolloBasicTextField} from "../../../molecule/Apollo_BaseItem";
import {Advertisement, AdvertisementCreate, AdvertisementUpdate, initAchievement} from "./common/AdvertisementModel";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import MUIDataTable, {MUISortOptions, SelectableRows} from "mui-datatables";
import {createMuiTheme} from "@material-ui/core/styles";
import AdAssetsDetail from "../../CRASSET/ms/AdAssetsDetail";
import moment from "moment";
import {
    AD_REVIEW_STATUS_BEFORE_REVIEW,
    AdProcessType,
    BLANK,
    INIT_AD_STATUS,
    INIT_NUMBER,
    INIT_STR,
    MSG,
    options_ms_ad_denial_reason,
    options_ms_ad_review_state,
} from "./common/CommonConst";
import {ARCHIVE_VALUE_NO, RESULT_KBN, CAMPAIGN_TYPE} from "../../CAMPAIGN/ms/common/CommonConst";
import {AdGroup} from "../../ADGROUP/ms/common/AdGroupModel";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {
    checkInvalidTabCharsForName,
    getTrackingArrayItems,
    getTrackingMacroLength,
    joinTrackingValue,
    TrackingPointItem,
    transferTargetInfo
} from "../../../common/Apollo_CommonUtil";
import {ApolloAxios} from "../../../atom/Apollo_ApiRequest3";
import {STORAGE_KEY} from "../../../atom/Apollo_DataTable";
import {APOLLO_PAGE_ID, createApolloPageSizeTableOptions} from "../../../common/Apollo_LocalStorageSettings";
import {cloneDeep} from "lodash";
import {AdGroupProcessType} from "../../ADGROUP/ms/common/CommonConst";
import {
    ApolloEventRecord,
    createLogDate,
    createUserLogItemListFromNumber, createUserLogItemListFromOptionValue,
    createUserLogItemListFromString,
    ItemList,
    LogData
} from "../../../atom/Apollo_EventRecord";

type LogRecord = {
    data: Advertisement
}

type TrackingItem = {
    id: number,
    key: string,
    value: string,
}

type AdEditProps = {
    accountId: number;
    platformaccountId: number;
    campaignId: number;
    adGroupId: number;
    adId: number | null;
    processType: string;
    listReloadFunc?: any;
}

type SelectedAsset = {
    assetId: number;
    assetName: string;
}

type CampaignForOption = {
    campaignType: number;
    id: number;
    name: string;
}

type AdGroupForOption = {
    campaignId: number;
    adGroupId: number;
    adGroupName: string;
    trackingParam: string;
}

const apollo_AdStyles = makeStyles({
    previewModalMs: {
        overflow: "auto",
        height: "90%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    assetListModalMs: {
        top: "40%",
        left: "50%",
        transform: "translate(-40%, -50%)",
    },
});

export const initAdvertisement: Advertisement = {
    adAccountId: 0,
    campaignId: 0,
    campaignName: INIT_STR,
    campaignStatus: INIT_NUMBER,
    adGroupId: INIT_NUMBER,
    adGroupName: INIT_STR,
    adGroupStatus: INIT_NUMBER,
    creativeId: INIT_NUMBER,
    creativeName: INIT_STR,
    creativeStatus: INIT_AD_STATUS,
    adAssetId: INIT_NUMBER,
    adAssetName: INIT_STR,
    trackingParam: INIT_STR,
    trackingParamAdGroup: INIT_STR,
    reviewStatus: 1,
    denialReason: INIT_NUMBER,
    denialReasonDetail: INIT_STR,
    createdDatetime: INIT_STR,
    updatedDatetime: INIT_STR,
    lastUpdatedUserId: INIT_STR,
    lastUpdatedVer: INIT_STR,
    achievement: initAchievement,
    assetImageUrl: INIT_STR,
    campaignType: 1,
}

/*
    画面名：広告編集（MS）
 */
const AdvertisementsEditMs: React.FC<AdEditProps> = ({
                                                         accountId,
                                                         platformaccountId,
                                                         campaignId,
                                                         adGroupId,
                                                         adId,
                                                         processType,
                                                         listReloadFunc,
                                                     }) => {

    // style
    const classes = apollo_useStyles();
    const adClasses = apollo_AdStyles();

    // history
    const history = useHistory();

    // useContext
    const {state: apolloContex} = React.useContext(ApolloContext);
    const {data: msg, setmsg} = React.useContext(ApolloMessage);

    // form
    const {
        register,
        handleSubmit,
        control,
        errors,
        formState,
        clearErrors,
        setValue
    } = useForm({reValidateMode: 'onBlur'});

    // useState
    const [advertisement, setAdvertisement] = useState<Advertisement>(initAdvertisement)

    const [openAssetList, setOpenAssetList] = React.useState(false);
    const [openPreview, setOpenPreview] = React.useState(false);
    const [openTrackingAlert, setOpenTrackingAlert] = React.useState(false);
    const [selectedAsset, setSelectedAsset] = useState<SelectedAsset | null>(null)
    const [trackingItems, setTrackingItems] = useState<TrackingItem[]>([])
    const [campaignList, setCampaignList] = useState<CampaignForOption[]>([])
    const [adGroupList, setAdGroupList] = useState<AdGroupForOption[]>([])

    // useRef
    const trackingItemMaxNo = useRef(0)
    const isOkTrackingAlert = useRef(false)
    const beforeEditRecord = useRef<LogRecord | null>(null);
    const processing = useRef(false);

    // function
    const previewCloseButtonClick = () => {
        setOpenPreview(false);
    };

    const trackingAlertCloseButtonClick = () => {
        setOpenTrackingAlert(false);
    };

    const trackingAlertContinueButtonClick = () => {
        setOpenTrackingAlert(false);
        isOkTrackingAlert.current = true;
        onSubmit()
    };

    const adListCloseButtonClick = () => {
        setOpenAssetList(false);
    };

    const onAddTrackingItem = ((event: any) => {
        trackingItemMaxNo.current++
        setTrackingItems([...trackingItems, {id: trackingItemMaxNo.current, key: BLANK, value: BLANK}])
    });

    // etc
    const options_campaignNames =
        campaignList?.filter(campaignName => campaignName.campaignType === advertisement.campaignType).map(campaignName => ({
            value: campaignName.id,
            label: `${campaignName.id}_${campaignName.name}`
        }))

    const options_adGroupNames =
        adGroupList?.filter(adGroupName => adGroupName.campaignId === advertisement.campaignId).map(adGroup => ({
            value: adGroup.adGroupId,
            label: `${adGroup.adGroupId}_${adGroup.adGroupName}`
        }))

    // function
    const goBack = (campaignId: number, adGroupId: number) => {
        const queryParams = (campaignId !== 0 && adGroupId !== 0) ? `?campaignId=${campaignId}&adGroupId=${adGroupId}` : "";
        processType === AdProcessType.create ?
            history.push(`${advertisementsms_path}${platformaccountId}/${accountId}/${platformaccountId}${queryParams}`) :
            listReloadFunc && listReloadFunc()
    };

    const onSubmit = handleSubmit(async (formData: any) => {

        let isSuccess = false;
        if (formState.isSubmitting) return;
        if (processing.current) return;

        if (selectedAsset === null) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...msg,
                    open: true,
                    type: "error",
                    message: "アセットを設定してください。"
                }
            });
            return
        }

        const trackingParams = joinTrackingValue(trackingItems);

        if (getTrackingMacroLength(trackingItems) > 1200) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...msg,
                    open: true,
                    type: "error",
                    message: "トラッキングパラメータの値が1200バイトを超えています。"
                }
            });
            return
        }

        if (!isOkTrackingAlert.current &&
            advertisement.trackingParamAdGroup != "" &&
            trackingParams != advertisement.trackingParam &&
            trackingItems.length > 0) {
            setOpenTrackingAlert(true);
            return;
        }

        const editLogInfo = createUserLog(
            apolloContex,
            "メール広告",
            "広告",
            processType,
            processType === AdProcessType.create ? "広告（MS）作成" : "広告（MS）編集",
            beforeEditRecord.current,
            {
                data: {
                    ...cloneDeep(advertisement),
                    trackingParam: trackingParams,
                    adAssetId: selectedAsset.assetId,
                    adAssetName: selectedAsset.assetName,
                },
            },
            {
                status: options_state_edit_ms,
                campaignType: options_ms_campaign_type,
            },
            String(advertisement.campaignId) ?? BLANK,
            String(advertisement.campaignName) ?? BLANK,
            String(advertisement.adGroupId) ?? BLANK,
            String(advertisement.adGroupName) ?? BLANK,
        )
        ApolloEventRecord({...editLogInfo, logType: "execute"})

        processing.current = true;

        if (processType === AdProcessType.create) {

            const url = `${process.env.REACT_APP_API_ENDPOINT}${post_ms_advertisement_path}`
            const advertisementCreate: AdvertisementCreate = {
                adAccountId: platformaccountId,
                campaignId: advertisement.campaignId,
                adGroupId: advertisement.adGroupId,
                creativeName: advertisement.creativeName,
                creativeStatus: advertisement.creativeStatus,
                adAssetId: selectedAsset.assetId,
                trackingParam: trackingParams,
                userId: apolloContex.userprofile.userId.toString(),
            }

            let registedId = BLANK

            await ApolloAxios.post(
                url,
                advertisementCreate,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                    }
                })
                .then((response) => {
                    if (response.data.resultcode == RESULT_KBN.SUCCESS) {
                        registedId = response.data.registedId?.toString() ?? BLANK
                        isSuccess = true;
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "success",
                                message: MSG.SUCCESS_POST_ADVERTISEMENT
                            }
                        });
                    } else {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_POST_ADVERTISEMENT}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_POST_ADVERTISEMENT}${err?.errmsg ?? BLANK}`
                        }
                    });
                }).finally(() => {
                    processing.current = false;
                    const eventRecords: LogData = {
                        ...editLogInfo,
                        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                        targetID: registedId,
                        targetName: advertisement.creativeName,
                        logType: "result",
                        result: isSuccess ? "成功" : "失敗"
                    }
                    ApolloEventRecord(eventRecords)
                    goBack(campaignId, adGroupId);
                });
        } else {

            if (advertisement.campaignType == CAMPAIGN_TYPE.RTM) {
                processing.current = false
                setmsg({
                    type: "setMessage",
                    payload: {
                      ...msg,
                      open: true,
                      type: "error",
                      message: `${"リアルタイムメッセージSのキャンペーンに紐づく広告は変更できません。"}`,
                    }
                  });
                return;
            }

            const url = `${process.env.REACT_APP_API_ENDPOINT}${put_ms_advertisement_path}`
            const msAdvertisementUpdate: AdvertisementUpdate = {
                adAccountId: platformaccountId,
                creativeId: advertisement.creativeId,
                creativeName: advertisement.creativeName,
                creativeStatus: advertisement.creativeStatus,
                adAssetId: selectedAsset.assetId,
                trackingParam: trackingParams,
                userId: apolloContex.userprofile.userId.toString(),
                lastUpdatedVer: advertisement.lastUpdatedVer,
            }

            await ApolloAxios.put(
                url,
                msAdvertisementUpdate,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                    }
                })
                .then((response) => {
                    if (response.data.resultcode == RESULT_KBN.SUCCESS) {
                        isSuccess = true;
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "success",
                                message: MSG.SUCCESS_PUT_ADVERTISEMENT
                            }
                        });
                    } else {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_PUT_ADVERTISEMENT}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_PUT_ADVERTISEMENT}${err?.errmsg ?? BLANK}`
                        }
                    });
                }).finally(() => {
                    processing.current = false;
                    const eventRecords: LogData = {
                        ...editLogInfo,
                        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                        targetID: advertisement.creativeId.toString(),
                        targetName: advertisement.creativeName,
                        logType: "result",
                        result: isSuccess ? "成功" : "失敗"
                    }
                    ApolloEventRecord(eventRecords)
                    goBack(campaignId, adGroupId);
                });
        }
    });

    useEffect(() => {

        const fetchMsAdGroup = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_adgroup_path}/${platformaccountId}/${campaignId}/${adGroupId}`
            await ApolloAxios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apolloContex.accesstoken}`,
                }
            })
                .then((response) => {
                    if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                        const resultData: AdGroup = response.data.result
                        setAdvertisement({
                            ...advertisement,
                            adGroupName: resultData.adGroupName,
                            trackingParamAdGroup: resultData.trackingParam,
                            adGroupId: resultData.adGroupId,
                            campaignType: resultData.campaignType,
                            campaignName: resultData.campaignName,
                            campaignId: resultData.campaignId,
                        })
                    } else {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_ADGROUP}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_ADGROUP}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
        }

        const fetchMsCampaignList = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_campaigns_path}/${platformaccountId}`;
            await ApolloAxios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apolloContex.accesstoken}`,
                }
            })
                .then((response) => {
                    if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                        if (response.data.result?.length > 0) {
                            const campaignList = response.data ?
                                response.data.result.map((elem: any) => {
                                    return {
                                        id: elem.id,
                                        name: elem.name,
                                        campaignType: elem.campaignType,
                                    }
                                }) : []
                            setCampaignList(campaignList)
                        }
                    } else if (response.data.resultcode === RESULT_KBN.ERROR) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_CAMPAIGN}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_CAMPAIGN}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
        }

        const fetchMsAdGroupList = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_adgroups_path}/${platformaccountId}/0`
            await ApolloAxios.get(
                url,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                    }
                }
            ).then((response) => {
                if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                    setAdGroupList(response.data.result)
                } else if (response.data.resultcode === RESULT_KBN.ERROR) {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_ADGROUP}${response?.data?.message ?? BLANK}`
                        }
                    });
                }
            }).catch(err => {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...msg,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_GET_ADGROUP}${err?.errmsg ?? BLANK}`
                    }
                });
            });
        };

        const fetchMsAdvertisement = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_advertisement_path}/${platformaccountId}/${campaignId}/${adGroupId}/${adId}`
            await ApolloAxios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apolloContex.accesstoken}`,
                }
            })
                .then((response) => {
                    if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                        const resultData: Advertisement = response.data.result
                        setAdvertisement(resultData)
                        setSelectedAsset({assetId: resultData.adAssetId, assetName: resultData.adAssetName})
                        const trackingItems = getTrackingArrayItems(response.data.result.trackingParam)
                        setTrackingItems(trackingItems)
                        trackingItemMaxNo.current = trackingItems.length
                        beforeEditRecord.current = {
                            data: cloneDeep(resultData)
                        }
                    } else {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...msg,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_ADVERTISEMENT}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...msg,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_ADVERTISEMENT}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
        }

        if (processType === AdProcessType.create) {

            const fetchAll = async () => {
                setmsg({
                    type: "loading",
                    payload: {
                        ...msg,
                        loading: true
                    }
                })

                if (campaignId === 0) {
                    await Promise.all(
                        [fetchMsCampaignList(), fetchMsAdGroupList()]
                    ).finally(() => {
                        setmsg({
                            type: "loading",
                            payload: {
                                ...msg,
                                loading: false
                            }
                        })
                    })
                } else {
                    await Promise.all(
                        [fetchMsAdGroup(), fetchMsCampaignList(), fetchMsAdGroupList()]
                    ).finally(() => {
                        setmsg({
                            type: "loading",
                            payload: {
                                ...msg,
                                loading: false
                            }
                        })
                    })

                }
            }
            fetchAll();

        } else if (processType === AdProcessType.edit) {


            const fetchAll = async () => {
                setmsg({
                    type: "loading",
                    payload: {
                        ...msg,
                        loading: true
                    }
                })

                await Promise.all(
                    [fetchMsAdvertisement()]
                ).finally(() => {
                    setmsg({
                        type: "loading",
                        payload: {
                            ...msg,
                            loading: false
                        }
                    })
                })
            }
            fetchAll();

        }

    }, [])

    return (
        <React.Fragment>
            <form noValidate onSubmit={onSubmit}>
                <Card className={classes.root} square variant="outlined">
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <TextField
                                    id="campaignName"
                                    label="メニュー"
                                    fullWidth
                                    value="メール広告"
                                    disabled={true}
                                />
                            </Grid>
                            {processType === AdProcessType.create ?
                                <React.Fragment>
                                    <Grid item xs={12}>
                                        <ApolloBasicSelect
                                            id="campaignType"
                                            label="キャンペーン"
                                            options={options_select_ms_campaign_type}
                                            value={advertisement.campaignType}
                                            control={control}
                                            rules={{
                                                validate: (e: any) => {
                                                    return e || "必須入力項目です。";
                                                }
                                            }}
                                            errors={errors}
                                            setState={(e: any) => setAdvertisement({
                                                ...advertisement,
                                                campaignType: e,
                                                campaignId: 0,
                                                adGroupId: 0,
                                            })
                                            }
                                            setValue={(name: string, value: any) => setValue(name, value)}
                                            placeholder="キャンペーン種別を選択"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <ApolloBasicSelect
                                            id="campaignName"
                                            label=""
                                            options={options_campaignNames}
                                            value={advertisement.campaignId || 0}
                                            control={control}
                                            disabled={!advertisement.campaignType}
                                            rules={{
                                                validate: (e: any) => {
                                                    if (e === null || e === 0) {
                                                        return "必須入力項目です。"
                                                    }
                                                }
                                            }}
                                            errors={errors}
                                            setState={(e: any) => {
                                                setAdvertisement({
                                                    ...advertisement,
                                                    campaignName: valueToLabel(e, options_campaignNames),
                                                    campaignId: e,
                                                    adGroupId: 0,
                                                    trackingParamAdGroup: "",
                                                })
                                            }
                                            }
                                            setValue={(name: string, value: any) => setValue(name, value)}
                                            placeholder="キャンペーン名を選択"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <ApolloBasicSelect
                                            id="adGroupName"
                                            label="広告グループ"
                                            options={options_adGroupNames}
                                            value={advertisement.adGroupId || 0}
                                            control={control}
                                            disabled={!advertisement.campaignId}
                                            rules={{
                                                validate: (e: any) => {
                                                    if (e === null || e === 0) {
                                                        return "必須入力項目です。"
                                                    }
                                                }
                                            }}
                                            errors={errors}
                                            setState={(e: any) => {
                                                const adGroupListFilterted = adGroupList.filter(elem => elem.adGroupId === e)
                                                const trackingParamAdGroup = adGroupListFilterted[0].trackingParam
                                                setAdvertisement({
                                                    ...advertisement,
                                                    adGroupName: valueToLabel(e, options_adGroupNames),
                                                    adGroupId: e,
                                                    trackingParamAdGroup: trackingParamAdGroup,
                                                })
                                            }
                                            }
                                            setValue={(name: string, value: any) => setValue(name, value)}
                                            placeholder="広告グループ名を選択"
                                        />
                                    </Grid>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom component="div">
                                            {"キャンペーン"}
                                        </Typography>
                                        <TextField
                                            id="campaignName"
                                            label="キャンペーン種別"
                                            fullWidth
                                            value={valueToLabel(advertisement.campaignType, options_ms_campaign_type)}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="campaignName"
                                            label="メール広告キャンペーン名"
                                            fullWidth
                                            value={`${advertisement.campaignId}_${advertisement.campaignName}`}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom component="div">
                                            {"広告グループ"}
                                        </Typography>
                                        <TextField
                                            id="campaignName"
                                            label="広告グループ名"
                                            fullWidth
                                            value={`${advertisement.adGroupId}_${advertisement.adGroupName}`}
                                            disabled={true}
                                        />
                                    </Grid>
                                </React.Fragment>
                            }
                        </Grid>
                        <Grid container spacing={3}>
                            {[
                                <Divider/>,
                                <ApolloBasicTextField
                                    id="adName"
                                    label="広告名"
                                    value={advertisement.creativeName}
                                    error={errors.adName}
                                    required={true}
                                    inputRef={register({
                                        required: "必須入力項目です",
                                        maxLength: {
                                            value: 255,
                                            message: "255文字以内で入力して下さい。"
                                        },
                                        validate: (e: string) => {
                                            const errorMessage = checkInvalidTabCharsForName(e)
                                            if(errorMessage) {
                                                return errorMessage
                                            }},
                                    })}
                                    setState={(e: any) => setAdvertisement({...advertisement, creativeName: e})}
                                />,
                                <ApolloBasicSelect
                                    id="status"
                                    label="ステータス"
                                    options={processType === AdProcessType.create
                                        ? options_state_edit_ms.filter(value => value.value !== ARCHIVE_VALUE_NO)
                                        : options_state_edit_ms}
                                    value={advertisement.creativeStatus}
                                    control={control}
                                    errors={errors}
                                    setState={(e: any) => setAdvertisement({...advertisement, creativeStatus: e})}
                                />,
                                processType === AdProcessType.edit ?
                                    <ApolloBasicSelect
                                        id="reviewStatus"
                                        label="審査ステータス"
                                        options={options_ms_ad_review_state}
                                        value={advertisement.reviewStatus}
                                        control={control}
                                        errors={errors}
                                        setState={(e: any) => setAdvertisement({...advertisement, reviewStatus: e})}
                                        disabled={true}
                                    /> : <></>,
                                processType === AdProcessType.edit && advertisement.reviewStatus === 5
                                    ? <ApolloBasicTextField
                                        id="denialReason"
                                        label="否認理由"
                                        value={valueToLabel(advertisement.denialReason, options_ms_ad_denial_reason)}
                                        error={errors.denialReason}
                                        setState={(e: any) => setAdvertisement({...advertisement, denialReason: e})}
                                        disabled={true}
                                    />
                                    : null,
                                processType === AdProcessType.edit && advertisement.reviewStatus === 5
                                    ? <ApolloBasicTextField
                                        id="denialReasonDetail"
                                        label="否認理由詳細"
                                        value={advertisement.denialReasonDetail}
                                        error={errors.denialReasonDetail}
                                        setState={(e: any) => setAdvertisement({...advertisement, denialReasonDetail: e})}
                                        disabled={true}
                                    />
                                    : null,
                                <Divider/>,
                                <React.Fragment>
                                    <Typography variant="subtitle1" gutterBottom component="div">
                                        広告アセット*
                                    </Typography>
                                    <Button type="button"
                                            variant="contained"
                                            disabled={advertisement.reviewStatus !== AD_REVIEW_STATUS_BEFORE_REVIEW}
                                            color="primary"
                                            onClick={() => {
                                                setOpenAssetList(true);
                                            }}>
                                        {selectedAsset === null ? "追加" : "変更"}
                                    </Button>
                                    {selectedAsset === null ? <></> :
                                        <Card className={classes.root} square variant="outlined">
                                            <CardContent>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={4} style={{marginBottom: "10px"}}>
                                                        広告アセットID
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        広告アセット名
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        プレビュー
                                                    </Grid>
                                                </Grid>
                                                <Divider/>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={4} style={{marginTop: "25px"}}>
                                                        {selectedAsset.assetId}
                                                    </Grid>
                                                    <Grid item xs={4} style={{marginTop: "25px", overflowX: "scroll"}}>
                                                        <div style={{display: "inline-block", whiteSpace: "nowrap"}}>{selectedAsset.assetName}</div>
                                                    </Grid>
                                                    <Grid item xs={4} style={{marginTop: "25px"}}>
                                                        <ZoomInIcon
                                                            onClick={e => setOpenPreview(true)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    }
                                </React.Fragment>,
                                <Divider/>,
                                <Grid container spacing={1}>
                                    <Grid container item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom component="div">
                                            トラッキングパラメータ
                                            <p style={{color: "grey"}}>広告グループでのトラッキングパラメータ設定値</p>
                                        </Typography>
                                        <TextField
                                            value={advertisement.trackingParamAdGroup ? advertisement.trackingParamAdGroup : "未設定"}
                                            disabled={true}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid container item xs={12} style={{marginTop: "15px"}}>
                                        <Button type="button"
                                                variant="contained"
                                                disabled={advertisement.reviewStatus !== AD_REVIEW_STATUS_BEFORE_REVIEW}
                                                color="primary"
                                                onClick={onAddTrackingItem}>追加</Button>
                                    </Grid>
                                    <TrackingPointItem values={trackingItems}
                                                       setState={setTrackingItems}
                                                       register={register}
                                                       errors={errors}
                                                       clearErrors={clearErrors}
                                                       disabled={advertisement.reviewStatus !== AD_REVIEW_STATUS_BEFORE_REVIEW}
                                    />
                                    <Grid container item xs={12}>
                                        <p>※リンク先URLの末尾に上記で設定したパラメータを設定いたします。<br/>
                                            ※広告グループ・広告両方にパラメータを設定した場合、広告のパラメータのみを設定いたします。</p>
                                    </Grid>
                                </Grid>
                                ,
                                <Divider/>
                            ].map((value) => {
                                return (
                                    <Grid item xs={12}>
                                        {value}
                                    </Grid>
                                )
                            })
                            }
                        </Grid>
                    </CardContent>
                    <CardActions className={classes.cardaction}>
                        <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={formState.isSubmitting}
                                onClick={onSubmit}
                                className={classes.button}
                            >
                                {processType === AdProcessType.create ? "作成" : "更新"}
                            </Button>
                        </ApolloUserProfileAuth>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={e => goBack(campaignId, adGroupId)}
                            className={classes.button}
                        >
                            戻る
                        </Button>
                    </CardActions>
                </Card>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={openAssetList}
                    onClose={adListCloseButtonClick}
                >
                    <div className={`${classes.paper} ${adClasses.assetListModalMs}`}>
                        <AdAssetList
                            platformaccountid={platformaccountId}
                            advertisement={advertisement}
                            setSelectedAsset={setSelectedAsset}
                            setOpenAssetList={setOpenAssetList}
                        />
                    </div>
                </Modal>
                <Modal
                    className={adClasses.previewModalMs}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={openPreview}
                    onClose={previewCloseButtonClick}
                >
                    {
                        selectedAsset !== null ?
                            <div style={{height: "90%"}}>
                                <AdAssetsDetail platformAccountId={platformaccountId}
                                                assetId={selectedAsset.assetId}/>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={previewCloseButtonClick}
                                    className={classes.button}
                                >
                                    閉じる
                                </Button>
                            </div>
                            : <></>
                    }
                </Modal>
                <Modal
                    className={adClasses.previewModalMs}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={openTrackingAlert}
                    onClose={trackingAlertCloseButtonClick}
                >
                    <Card className={classes.root} square variant="outlined">
                        <CardContent>
                            <Grid container spacing={1}>
                                <Grid container item xs={12}>
                                    広告グループに、トラッキングパラメータが設定されています。<br/>
                                    広告のパラメータを設定/更新する場合、広告グループに設定されたパラメータよりも広告に設定したパラメータが優先されます。<br/>
                                    このまま設定/更新を続けますか。<br/>
                                </Grid>
                                <Grid container item xs={3}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={trackingAlertContinueButtonClick}
                                        className={classes.button}
                                    >
                                        OK
                                    </Button>
                                </Grid>
                                <Grid container item xs={3}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={trackingAlertCloseButtonClick}
                                        className={classes.button}
                                    >
                                        NO
                                    </Button>
                                </Grid>
                                <Grid container item xs={6}>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Modal>
            </form>
        </React.Fragment>
    );
};

const AdAssetList: React.FC<{
    platformaccountid: number,
    advertisement: Advertisement,
    setSelectedAsset: any,
    setOpenAssetList: any,
}> = ({platformaccountid, advertisement, setOpenAssetList, setSelectedAsset}) => {

    // style
    const classes = apollo_useStyles();
    const adClasses = apollo_AdStyles();

    const tableTheme = createMuiTheme({
        palette: {
            primary: {
                main: colors.blue[300],
                light: '#fff',
                contrastText: '#fff',
            },
        },
    });

    // useContext
    const {state: apolloContex} = React.useContext(ApolloContext);
    const {data, setmsg} = React.useContext(ApolloMessage);

    // useState
    const [adAssets, setAdAssets] = useState<AdAsset[]>([]);
    const [selectedIndex, setSelectedIndex] = useState<number[]>([])
    const [clickPreviewIndex, setClickPreviewIndex] = useState<number | null>(null)

    const [open, setOpen] = React.useState(false);

    // function
    const handleClose = () => {
        setOpen(false);
    };

    // useEffect
    useEffect(() => {
        const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_assets_path}/${platformaccountid}`;
        const fetchData = async () => {
            await ApolloAxios.get(
                url,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                    }
                }
            ).then((response) => {
                if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                    setAdAssets(response.data.adAssets);
                } else {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...data,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_ADASSET}${response?.data?.message ?? BLANK}`
                        }
                    });
                }
            }).catch(err => {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...data,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_GET_ADASSET}${err?.errmsg ?? BLANK}`
                    }
                });
            });
        };
        fetchData();

    }, [])

    const sortOrder: MUISortOptions = {
        name: "adAssetId",
        direction: 'desc',
    }
    // tableConfig
    const selectableRows: SelectableRows = 'single';
    const listOptions = createApolloPageSizeTableOptions({
        selectableRowsHeader: true,
        filter: false,
        sortOrder: localStorage.getItem(STORAGE_KEY.MS_ADVERTISEMENTS_EDIT) ? undefined : sortOrder,
        viewColumns: false,
        download: false,
        print: false,
        sort: true,
        search: true,
        rowsSelected: selectedIndex,
        selectableRows: selectableRows,
        rowsPerPage: 5,
        rowsPerPageOptions: [5, 10, 20],
        jumpToPage: true,
        expandableRows: false,
        expandableRowsHeader: false,
        selectableRowsOnClick: true,
        selectableRowsHideCheckboxes: true,
        storageKey: STORAGE_KEY.MS_ADVERTISEMENTS_EDIT,
        customToolbarSelect: () => undefined,
        onRowSelectionChange: (currentRowSelected: any, allRowSelected: any, rowSelected: any) => {
            setSelectedIndex(rowSelected ?? [])
        },
    }, APOLLO_PAGE_ID.AD_EDIT_MS)

    const columns = [
        {
            name: "adAssetId",
            label: "広告アセットID",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "adAssetName",
            label: "広告アセット名",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "",
            options: {
                filter: false,
                sort: false,
                viewColumns: false,
                customBodyRenderLite: (dataIndex: any, rowIndex: any) => {
                    return (
                        <ZoomInIcon
                            onClick={() => {
                                setClickPreviewIndex(dataIndex)
                                setOpen(true);
                            }}
                        />
                    );
                }
            }
        },
        {
            name: "updatedDatetime",
            label: "最終更新日",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value: string) => {
                    return moment(value).format("YYYY-MM-DD");
                },

            },
        },
    ];

    // etc
    const selectedAssetId = selectedIndex.length > 0 ?
        adAssets.length > 0 ? adAssets[selectedIndex[0]].adAssetId : 0
        : 0

    return (
        <React.Fragment>
            アセット紐づけ
            <Modal
                className={adClasses.previewModalMs}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={open}
                onClose={handleClose}
            >
                <div style={{height: "90%"}}>
                    {clickPreviewIndex !== null ?
                        <AdAssetsDetail platformAccountId={platformaccountid}
                                        assetId={adAssets[clickPreviewIndex].adAssetId
                                        }
                        /> : <></>}
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleClose}
                        className={classes.button}
                    >
                        閉じる
                    </Button>
                </div>
            </Modal>
            <Card className={classes.root} square variant="outlined">
                <CardContent>
                    <Card className={classes.root} square variant="outlined">
                        <MuiThemeProvider theme={tableTheme}>
                            <MUIDataTable
                                title="アセット一覧"
                                data={adAssets ?? []}
                                columns={columns}
                                options={listOptions}
                            />
                        </MuiThemeProvider>
                    </Card>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setSelectedAsset(null)
                            if (selectedIndex.length === 1) {
                                const index = selectedIndex[0]
                                const adAsset = adAssets[index]
                                setSelectedAsset({
                                    assetId: adAsset.adAssetId,
                                    assetName: adAsset.adAssetName,
                                })
                            }
                            setOpenAssetList(false);
                        }}
                        className={classes.button}
                    >
                        選択
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setOpenAssetList(false);
                        }}
                        className={classes.button}
                    >
                        閉じる
                    </Button>
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

const valueToLabel = function (value: any, options: Array<{ value: any; label: string }>): string {
    let option = options?.find(option => option.value === value)
    if (!option) {
        return ""
    } else {
        return option.label
    }
}

const createUserLog = (
    apolloContex: any,
    menu: string,
    category: string,
    actionType: string,
    displayName: string,
    beforeInfo: LogRecord | null,
    afterInfo: LogRecord,
    optionMaster: {
        status: any,
        campaignType: any,
    },
    campaignId?: string,
    campaignName?: string,
    adGroupId?: string,
    adGroupName?: string,
) => {

    const beforeData = beforeInfo?.data ?? null
    const afterData = afterInfo?.data

    const items: ItemList[] = [
        createUserLogItemListFromOptionValue("キャンペーン種別", "campaignType", beforeData, afterData, optionMaster.campaignType),
        createUserLogItemListFromString("キャンペーン名", "campaignName", beforeData, afterData),
        createUserLogItemListFromString("広告グループ名", "adGroupName", beforeData, afterData),
        createUserLogItemListFromString("広告名", "creativeName", beforeData, afterData),
        createUserLogItemListFromOptionValue("ステータス", "creativeStatus", beforeData, afterData, optionMaster.status),
        createUserLogItemListFromNumber("広告アセットID", "adAssetId", beforeData, afterData),
        createUserLogItemListFromNumber("広告アセット名", "adAssetName", beforeData, afterData),
        createUserLogItemListFromString("トラッキングパラメータ", "trackingParam", beforeData, afterData),
    ]

    const retObj = createLogDate(
        apolloContex,
        menu,
        category,
        actionType === AdGroupProcessType.create ? "作成" : "更新",
        displayName,
        items,
        campaignId,
        campaignName,
        adGroupId,
        adGroupName,
    )

    return retObj
}

export default AdvertisementsEditMs;
